import React from "react";
import "./style.scss";
import QRCode from "react-qr-code";
import useDesktopSize from "../../utils/hooks/useDesktopSize";

interface IProps {
  trhId: string;
  name: string;
}

const QrCodeModal: React.FC<IProps> = ({ name, trhId }: IProps) => {
  const isDesktop = useDesktopSize();
  return (
    <>
      <div className="qr-code-modal">
        {trhId && 
        <QRCode value={trhId} size={isDesktop ? 250 : 120} bgColor="#ffffff" /> }
        <b className="qr-name">{name}</b>
        <span className="qr-code-text">{trhId}</span>
      </div>
    </>
  );
};

export default QrCodeModal;
